import { COMPANY_TYPES } from '../../../../utils/common'
import {
  typeComponentBank,
  typeComponentCorporate,
  typeComponentLifeInsurance,
  typeComponentNonBank,
  typeComponentNonLifeInsurance,
  typeComponentSecurity,
  typeViewBy,
} from '../constant'

const getSettingPanel = (type) => {
  switch (type) {
    // corporate
    case typeComponentCorporate.QUICK_ASSESSMENT:
      return {}
    case typeComponentCorporate.PROFITABILITY:
      return {
        [typeViewBy.TREND]: [
          {
            label: null,
            indicators: [
              { id: 'FA165', enable: true },
              { id: 'RT0048', enable: true },
              { id: 'RT0050', enable: true },
              { id: 'RT0051', enable: true },
              { id: 'RT0052', enable: true },
              { id: 'RT0054', enable: true },
            ],
          },
        ],
        [typeViewBy.EACH_YEAR]: [
          {
            label: null,
            indicators: [
              { id: 'FA151' },
              { id: 'RT0050' },
              { id: 'RTI0050' },
              { id: 'RT0051' },
              { id: 'RTI0051' },
              { id: 'RT0052' },
              { id: 'RTI0052' },
              { id: 'RT0054' },
              { id: 'RTI0054' },
            ],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: null,
            indicators: [
              { id: 'FA165' },
              { id: 'RT0048' },
              { id: 'RT0049' },
              { id: 'RT0050' },
              { id: 'RTI0050' },
              { id: 'RT0051' },
              { id: 'RTI0051' },
              { id: 'RT0052' },
              { id: 'RTI0052' },
              { id: 'RT0054' },
              { id: 'RTI0054' },
            ],
          },
        ],
        companyType: COMPANY_TYPES.CORPORATE,
        ratioGroupCode: 'Profitability',
      }
    case typeComponentCorporate.ROA_AND_ROE:
      return {
        [typeViewBy.TREND]: [
          {
            label: null,
            indicators: [
              { id: 'RT0060' },
              { id: 'RTI0060' },
              { id: 'RT0059' },
              { id: 'RTI0059' },
            ],
          },
        ],
        [typeViewBy.EACH_YEAR]: [
          {
            label: null,
            indicators: [
              { id: 'RT0060' },
              { id: 'RT0059' },
              { id: 'RT0035' },
              { id: 'RT0054' },
              { id: 'RT0003' },
              { id: 'FA001' },
              { id: 'RT0065' },
              { id: 'RT0052' },
            ],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: null,
            indicators: [
              { id: 'RT0060' },
              { id: 'RTI0060' },
              { id: 'RT0059' },
              { id: 'RTI0059' },
              { id: 'RT0035' },
              { id: 'RT0054' },
              { id: 'RT0003' },
              { id: 'FA001' },
              { id: 'RT0065' },
              { id: 'RT0052' },
            ],
          },
        ],
        companyType: COMPANY_TYPES.CORPORATE,
        ratioGroupCode: 'RoaAndRoe',
      }
    case typeComponentCorporate.ASSET_MANAGEMENT_EFFICIENCY:
      return {
        [typeViewBy.TREND]: [
          {
            label: null,
            indicators: [
              { id: 'RT0009' },
              { id: 'RTI0009' },
              { id: 'RT0011' },
              { id: 'RTI0011' },
              { id: 'RT0013' },
              { id: 'RTI0013' },
              { id: 'RT0015' },
              { id: 'RTI0015' },
            ],
          },
        ],
        [typeViewBy.EACH_YEAR]: [
          {
            label: null,
            indicators: [
              { id: 'RT0009' },
              { id: 'RTI0009' },
              { id: 'RT0011' },
              { id: 'RTI0011' },
              { id: 'RT0013' },
              { id: 'RTI0013' },
              { id: 'RT0015' },
              { id: 'RTI0015' },
              { id: 'RT0006' },
              { id: 'RT0003' },
            ],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: null,
            indicators: [
              { id: 'RT0009' },
              { id: 'RTI0009' },
              { id: 'RT0011' },
              { id: 'RTI0011' },
              { id: 'RT0013' },
              { id: 'RTI0013' },
              { id: 'RT0015' },
              { id: 'RTI0015' },
              { id: 'RT0006' },
              { id: 'RT0003' },
            ],
          },
        ],
        companyType: COMPANY_TYPES.CORPORATE,
        ratioGroupCode: 'AssetManagementEfficiency',
      }
    case typeComponentCorporate.LIQUIDITY:
      return {
        [typeViewBy.TREND]: [
          {
            label: null,
            indicators: [
              { id: 'RT0020' },
              { id: 'RTI0020' },
              { id: 'RT0019' },
              { id: 'RTI0019' },
              { id: 'RT0018' },
              { id: 'RTI0018' },
            ],
          },
        ],
        [typeViewBy.EACH_YEAR]: [
          {
            label: null,
            indicators: [
              { id: 'RT0020' },
              { id: 'RTI0020' },
              { id: 'RT0019' },
              { id: 'RTI0019' },
              { id: 'RT0018' },
              { id: 'RTI0018' },
              { id: 'RT0001' },
              { id: 'RT0040' },
            ],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: null,
            indicators: [
              { id: 'RT0020' },
              { id: 'RTI0020' },
              { id: 'RT0019' },
              { id: 'RTI0019' },
              { id: 'RT0018' },
              { id: 'RTI0018' },
              { id: 'RT0001' },
              { id: 'RT0040' },
            ],
          },
        ],
        companyType: COMPANY_TYPES.CORPORATE,
        ratioGroupCode: 'Liquidity',
      }
    case typeComponentCorporate.SOLVENCY:
      return {
        [typeViewBy.TREND]: [
          {
            label: null,
            indicators: [
              { id: 'RT0027', enable: true },
              { id: 'RTI0027', enable: true },
              { id: 'RT0034', enable: true },
              { id: 'RTI0034', enable: true },
              { id: 'RT0037', enable: true },
              { id: 'RTI0037', enable: true },
            ],
          },
        ],
        [typeViewBy.EACH_YEAR]: [
          {
            label: null,
            indicators: [
              { id: 'RT0027' },
              { id: 'RT0034' },
              { id: 'RT0037' },
              { id: 'FA002' },
              { id: 'FA160' },
              { id: 'FA159' },
            ],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: null,
            indicators: [
              { id: 'RT0027' },
              { id: 'RTI0027' },
              { id: 'RT0034' },
              { id: 'RTI0034' },
              { id: 'RT0037' },
              { id: 'RTI0037' },
              { id: 'FA002' },
              { id: 'FA160' },
              { id: 'FA159' },
            ],
          },
        ],
        companyType: COMPANY_TYPES.CORPORATE,
        ratioGroupCode: 'Solvency',
      }
    case typeComponentCorporate.COVERAGE:
      return {
        [typeViewBy.TREND]: [
          {
            label: null,
            indicators: [
              { id: 'RT0044' },
              { id: 'RT0045' },
              { id: 'RT0046' },
              { id: 'RT0047' },
            ],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: null,
            indicators: [
              { id: 'RT0044' },
              { id: 'RT0045' },
              { id: 'RT0046' },
              { id: 'RT0047' },
            ],
          },
        ],
        companyType: COMPANY_TYPES.CORPORATE,
        ratioGroupCode: 'Coverage',
      }
    case typeComponentCorporate.EARNING_BREAKDOWN:
      return {
        [typeViewBy.TREND]: [
          {
            label: null,
            indicators: [
              { id: 'FA165', enable: true },
              { id: 'FA164', enable: true },
              { id: 'FA029', enable: true },
              { id: 'FA189', enable: true },
              { id: 'FA168', enable: true },
              { id: 'FA162', enable: true },
              { id: 'FA167', enable: true },
              { id: 'FA166', enable: true },
            ],
          },
        ],
        [typeViewBy.EACH_YEAR]: [
          {
            label: null,
            indicators: [
              { id: 'FA165' },
              { id: 'FA164' },
              { id: 'FA029' },
              { id: 'FA189' },
              { id: 'FA168' },
              { id: 'FA161' },
              { id: 'FA166' },
            ],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: null,
            indicators: [
              { id: 'FA165' },
              { id: 'FA164' },
              { id: 'FA029' },
              { id: 'FA189' },
              { id: 'FA168' },
              { id: 'FA162' },
              { id: 'FA167' },
              { id: 'FA161' },
              { id: 'FA166' },
            ],
          },
        ],
        companyType: COMPANY_TYPES.CORPORATE,
        ratioGroupCode: 'EarningsBreakdown',
      }
    case typeComponentCorporate.BALANCE_BREAKDOWN:
      return {
        [typeViewBy.TREND]: [
          {
            label: 'financialAnalysis.ASSET_STRUCTURE',
            indicators: [
              { id: 'BS2', enable: true },
              { id: 'FA003', enable: true },
              { id: 'FA004', enable: true },
              { id: 'BS18', enable: true },
              { id: 'FA005', enable: true },
              { id: 'FA006', enable: true },
              { id: 'BS64', enable: true },
              { id: 'RT0172', enable: true },
            ],
          },
          {
            label: 'financialAnalysis.LIABILITIES_STRUCTURE',
            indicators: [
              { id: 'FA013', enable: true },
              { id: 'FA016', enable: true },
              { id: 'FA015', enable: true },
              { id: 'FA014', enable: true },
              { id: 'FA017', enable: true },
              { id: 'BS65', enable: true },
              { id: 'FA018', enable: true },
            ],
          },
          {
            label: 'financialAnalysis.EQUITY_STRUCTURE',
            indicators: [
              { id: 'FA024', enable: true },
              { id: 'BS109', enable: true },
              { id: 'FA025', enable: true },
              { id: 'BS95', enable: true },
              { id: 'RT0173', enable: true },
            ],
          },
        ],
        [typeViewBy.EACH_YEAR]: [
          {
            label: 'financialAnalysis.ASSET_STRUCTURE',
            indicators: [
              { id: 'FA152' },
              { id: 'FA007' },
              { id: 'FA008' },
              { id: 'FA009' },
              { id: 'FA010' },
              { id: 'FA011' },
              { id: 'FA012' },
            ],
          },
          {
            label: 'financialAnalysis.RESOURCE_STRUCTURE',
            indicators: [
              { id: 'FA159' },
              { id: 'FA160' },
              { id: 'FA019' },
              { id: 'FA026' },
              { id: 'FA020' },
              { id: 'FA027' },
              { id: 'FA021' },
              { id: 'FA022' },
              { id: 'FA023' },
            ],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: 'financialAnalysis.ASSET_STRUCTURE',
            indicators: [
              { id: 'BS2' },
              { id: 'FA003' },
              { id: 'FA004' },
              { id: 'BS18' },
              { id: 'FA005' },
              { id: 'FA006' },
              { id: 'BS64' },
              { id: 'RT0172' },
            ],
          },
          {
            label: 'financialAnalysis.LIABILITIES_STRUCTURE',
            indicators: [
              { id: 'FA013' },
              { id: 'FA014' },
              { id: 'FA015' },
              { id: 'FA016' },
              { id: 'FA017' },
              { id: 'BS65' },
              { id: 'FA018' },
            ],
          },
          {
            label: 'financialAnalysis.EQUITY_STRUCTURE',
            indicators: [
              { id: 'FA024' },
              { id: 'BS109' },
              { id: 'FA025' },
              { id: 'BS95' },
              { id: 'RT0173' },
            ],
          },
        ],
        companyType: COMPANY_TYPES.CORPORATE,
        ratioGroupCode: 'BalanceSheetBreakdown',
      }
    case typeComponentCorporate.CASH_BREAKDOWN:
      return {
        [typeViewBy.TREND]: [
          {
            label: null,
            indicators: [
              { id: 'CF19', enable: true },
              { id: 'CF30', enable: true },
              { id: 'CF37', enable: true },
              { id: 'CF38', enable: true },
            ],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: null,
            indicators: [
              { id: 'CF19' },
              { id: 'CF30' },
              { id: 'CF37' },
              { id: 'CF38' },
            ],
          },
        ],
        companyType: COMPANY_TYPES.CORPORATE,
        ratioGroupCode: 'CashFlowBreakdown',
      }
    // bank
    case typeComponentBank.QUICK_ASSESSMENT:
      return {}
    case typeComponentBank.LOAN_BOOK_BREAKDOWN:
      return {
        [typeViewBy.TREND]: [
          {
            label: 'financialAnalysis.LOAN_PORTFOLIO_BY_QUALITY',
            indicators: [
              { id: 'NB66', enable: true },
              { id: 'NB67', enable: true },
              { id: 'NB68', enable: true },
              { id: 'NB69', enable: true },
              { id: 'NB70', enable: true },
              { id: 'FA146', enable: true },
              { id: 'FA147', enable: true },
            ],
          },
          {
            label: 'financialAnalysis.LOAN_PORTFOLIO_BY_TERM',
            indicators: [{ id: 'NB72' }, { id: 'NB73' }, { id: 'NB74' }],
          },
          {
            label: 'financialAnalysis.TOP_3_SECTOR_IN_LOAN_PORTFOLIO',
            indicators: [],
          },
          {
            label: 'financialAnalysis.LOAN_LOSS_TO_NPL',
            indicators: [],
          },
          {
            label: 'financialAnalysis.LOAN_LOSS_TO_TOTAL_LOAN',
            indicators: [],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: null,
            indicators: [
              { id: 'NB66' },
              { id: 'NB67' },
              { id: 'NB68' },
              { id: 'NB69' },
              { id: 'NB70' },
              { id: 'FA146' },
              { id: 'FA147' },
              { id: 'NB72' },
              { id: 'NB73' },
              { id: 'NB74' },
            ],
          },
        ],
        companyType: COMPANY_TYPES.BANK,
        ratioGroupCode: 'LoanBookBreakdownAndCoverage',
      }
    case typeComponentBank.DEPOSIT_AND_CREDIT:
      return {
        [typeViewBy.TREND]: [
          {
            label: null,
            indicators: [
              { id: 'BS178', enable: true },
              { id: 'BS158', enable: true },
              { id: 'RT0297', enable: true },
              { id: 'RT0296', enable: true },
            ],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: null,
            indicators: [
              { id: 'BS178' },
              { id: 'BS158' },
              { id: 'RT0297' },
              { id: 'RT0296' },
            ],
          },
        ],
        companyType: COMPANY_TYPES.BANK,
        ratioGroupCode: 'DepositAndCredit',
      }
    case typeComponentBank.AVERAGE_COST:
      return {
        [typeViewBy.TREND]: [
          {
            label: null,
            indicators: [
              { id: 'FA149', enable: true },
              { id: 'RT0239', enable: true },
              { id: 'FA061', enable: true },
              { id: 'FA169' },
            ],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: null,
            indicators: [
              { id: 'FA149' },
              { id: 'RT0239' },
              { id: 'FA061' },
              { id: 'FA169' },
            ],
          },
        ],
        companyType: COMPANY_TYPES.BANK,
        ratioGroupCode: 'AverageCostOfFinancingAndCreditCost',
      }
    case typeComponentBank.EARNING_QUALITY:
      return {
        [typeViewBy.TREND]: [
          {
            label: null,
            indicators: [
              { id: 'FA150' },
              { id: 'RT0252' },
              { id: 'RT0060' },
              { id: 'RT0059' },
            ],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: null,
            indicators: [
              { id: 'FA150' },
              { id: 'RT0252' },
              { id: 'RT0060' },
              { id: 'RT0059' },
            ],
          },
        ],
        companyType: COMPANY_TYPES.BANK,
        ratioGroupCode: 'EarningsQuality',
      }
    case typeComponentBank.CAPITAL_AND_LEVERAGE:
      return {
        [typeViewBy.TREND]: [
          {
            label: null,
            indicators: [{ id: 'RT0248' }, { id: 'NB219' }, { id: 'FA060' }],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: null,
            indicators: [{ id: 'RT0248' }, { id: 'NB219' }, { id: 'FA060' }],
          },
        ],
        companyType: COMPANY_TYPES.BANK,
        ratioGroupCode: 'CapitalAndLeverage',
      }
    case typeComponentBank.LIQUIDITY:
      return {
        [typeViewBy.TREND]: [
          {
            label: null,
            indicators: [
              { id: 'RT0277' },
              { id: 'FA111' },
              { id: 'RT0318' },
              { id: 'FA149' },
            ],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: null,
            indicators: [
              { id: 'RT0277' },
              { id: 'FA111' },
              { id: 'RT0318' },
              { id: 'FA149' },
            ],
          },
        ],
        companyType: COMPANY_TYPES.BANK,
        ratioGroupCode: 'Liquidity',
      }
    case typeComponentBank.FUNDING_STRUCTURE:
      return {
        [typeViewBy.TREND]: [
          {
            label: null,
            indicators: [
              { id: 'BS178' },
              { id: 'BS174' },
              { id: 'BS175' },
              { id: 'BS180' },
              { id: 'BS181' },
              { id: 'FA031' },
            ],
          },
        ],
        [typeViewBy.EACH_YEAR]: [
          {
            label: null,
            indicators: [
              { id: 'FA032' },
              { id: 'FA033' },
              { id: 'FA034' },
              { id: 'FA035' },
              { id: 'FA036' },
            ],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: null,
            indicators: [
              { id: 'BS178' },
              { id: 'FA032' },
              { id: 'BS174' },
              { id: 'FA033' },
              { id: 'BS175' },
              { id: 'FA034' },
              { id: 'BS180' },
              { id: 'FA035' },
              { id: 'BS181' },
              { id: 'FA036' },
              { id: 'FA156' },
              { id: 'FA031' },
            ],
          },
        ],
        companyType: COMPANY_TYPES.BANK,
        ratioGroupCode: 'Funding',
      }
    case typeComponentBank.BALANCE_BREAKDOWN:
      return {
        [typeViewBy.TREND]: [
          {
            label: 'financialAnalysis.ASSET_STRUCTURE',
            indicators: [
              { id: 'BS2', enable: true },
              { id: 'FA037', enable: true },
              { id: 'FA038', enable: true },
              { id: 'BS158', enable: true },
              { id: 'FA039', enable: true },
              { id: 'FA040', enable: true },
              { id: 'RT0296', enable: true },
              { id: 'RT0172', enable: true },
            ],
          },
          {
            label: 'financialAnalysis.LIABILITIES_STRUCTURE',
            indicators: [
              { id: 'BS174', enable: true },
              { id: 'BS175', enable: true },
              { id: 'BS178', enable: true },
              { id: 'BS181', enable: true },
              { id: 'FA047', enable: true },
              { id: 'FA048', enable: true },
            ],
          },
          {
            label: 'financialAnalysis.EQUITY_STRUCTURE',
            indicators: [
              { id: 'BS186', enable: true },
              { id: 'BS187', enable: true },
              { id: 'BS109', enable: true },
              { id: 'FA054', enable: true },
              { id: 'RT0173', enable: true },
            ],
          },
        ],
        [typeViewBy.EACH_YEAR]: [
          {
            label: 'financialAnalysis.ASSET_STRUCTURE',
            indicators: [
              { id: 'FA153' },
              { id: 'FA041' },
              { id: 'FA042' },
              { id: 'FA043' },
              { id: 'FA044' },
              { id: 'FA045' },
              { id: 'FA046' },
            ],
          },
          {
            label: 'financialAnalysis.RESOURCE_STRUCTURE',
            indicators: [
              { id: 'FA160' },
              { id: 'FA159' },
              { id: 'FA055' },
              { id: 'FA049' },
              { id: 'FA050' },
              { id: 'FA056' },
              { id: 'FA051' },
              { id: 'FA057' },
              { id: 'FA052' },
              { id: 'FA053' },
            ],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: 'financialAnalysis.ASSET_STRUCTURE',
            indicators: [
              { id: 'BS2' },
              { id: 'FA037' },
              { id: 'FA038' },
              { id: 'BS158' },
              { id: 'FA039' },
              { id: 'FA040' },
              { id: 'BS64' },
              { id: 'RT0296' },
              { id: 'RT0172' },
            ],
          },
          {
            label: 'financialAnalysis.LIABILITIES_STRUCTURE',
            indicators: [
              { id: 'BS174' },
              { id: 'BS175' },
              { id: 'BS178' },
              { id: 'FA052' },
              { id: 'FA047' },
              { id: 'BS65' },
              { id: 'FA048' },
            ],
          },
          {
            label: 'financialAnalysis.EQUITY_STRUCTURE',
            indicators: [
              { id: 'BS186' },
              { id: 'BS187' },
              { id: 'BS109' },
              { id: 'FA054' },
              { id: 'BS95' },
              { id: 'RT0173' },
            ],
          },
        ],
        companyType: COMPANY_TYPES.BANK,
        ratioGroupCode: 'BalanceSheetBreakdown',
      }
    case typeComponentBank.EARNING_BREAKDOWN:
      return {
        [typeViewBy.TREND]: [
          {
            label: null,
            indicators: [
              { id: 'IS27', enable: true },
              { id: 'IS30', enable: true },
              { id: 'FA059', enable: true },
              { id: 'IS39', enable: true },
              { id: 'IS41', enable: true },
              { id: 'IS16', enable: true },
            ],
          },
        ],
        [typeViewBy.EACH_YEAR]: [
          {
            label: null,
            indicators: [
              { id: 'IS27' },
              { id: 'IS30' },
              { id: 'FA059' },
              { id: 'IS39' },
              { id: 'IS41' },
              { id: 'IS16' },
            ],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: null,
            indicators: [
              { id: 'IS27' },
              { id: 'IS30' },
              { id: 'FA059' },
              { id: 'IS39' },
              { id: 'IS41' },
              { id: 'IS16' },
            ],
          },
        ],
        companyType: COMPANY_TYPES.BANK,
        ratioGroupCode: 'EarningsBreakdown',
      }
    case typeComponentBank.CASH_FLOW:
      return {
        [typeViewBy.TREND]: [
          {
            label: null,
            indicators: [
              { id: 'CF19', enable: true },
              { id: 'CF30', enable: true },
              { id: 'CF37', enable: true },
              { id: 'CF38', enable: true },
            ],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: null,
            indicators: [
              { id: 'CF19' },
              { id: 'CF30' },
              { id: 'CF37' },
              { id: 'CF38' },
            ],
          },
        ],
        companyType: COMPANY_TYPES.BANK,
        ratioGroupCode: 'CashFlowBreakdown',
      }
    // non bank
    case typeComponentNonBank.QUICK_ASSESSMENT:
      return {}
    case typeComponentNonBank.LOAN_BOOK_BREAKDOWN:
      return {
        [typeViewBy.TREND]: [
          {
            label: 'financialAnalysis.LOAN_PORTFOLIO_BY_QUALITY',
            indicators: [
              { id: 'NB66', enable: true },
              { id: 'NB67', enable: true },
              { id: 'NB68', enable: true },
              { id: 'NB69', enable: true },
              { id: 'NB70', enable: true },
              { id: 'FA146', enable: true },
              { id: 'FA147', enable: true },
            ],
          },
          {
            label: 'financialAnalysis.LOAN_PORTFOLIO_BY_TERM',
            indicators: [{ id: 'NB72' }, { id: 'NB73' }, { id: 'NB74' }],
          },
          {
            label: 'financialAnalysis.TOP_3_SECTOR_IN_LOAN_PORTFOLIO',
            indicators: [],
          },
          {
            label: 'financialAnalysis.LOAN_LOSS_TO_NPL',
            indicators: [],
          },
          {
            label: 'financialAnalysis.LOAN_LOSS_TO_TOTAL_LOAN',
            indicators: [],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: null,
            indicators: [
              { id: 'NB66' },
              { id: 'NB67' },
              { id: 'NB68' },
              { id: 'NB69' },
              { id: 'NB70' },
              { id: 'FA146' },
              { id: 'FA147' },
              { id: 'NB72' },
              { id: 'NB73' },
              { id: 'NB74' },
            ],
          },
        ],
        companyType: COMPANY_TYPES.NON_BANK,
        ratioGroupCode: 'LoanBookBreakdownAndCoverage',
      }
    case typeComponentNonBank.DEPOSIT_AND_CREDIT:
      return {
        [typeViewBy.TREND]: [
          {
            label: null,
            indicators: [
              { id: 'BS178', enable: true },
              { id: 'BS158', enable: true },
              { id: 'RT0297', enable: true },
              { id: 'RT0296', enable: true },
            ],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: null,
            indicators: [
              { id: 'BS178' },
              { id: 'BS158' },
              { id: 'RT0297' },
              { id: 'RT0296' },
            ],
          },
        ],
        companyType: COMPANY_TYPES.NON_BANK,
        ratioGroupCode: 'DepositAndCredit',
      }
    case typeComponentNonBank.AVERAGE_COST:
      return {
        [typeViewBy.TREND]: [
          {
            label: null,
            indicators: [
              { id: 'FA149', enable: true },
              { id: 'RT0239', enable: true },
              { id: 'FA061', enable: true },
              { id: 'FA169' },
            ],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: null,
            indicators: [
              { id: 'FA149' },
              { id: 'RT0239' },
              { id: 'FA061' },
              { id: 'FA169' },
            ],
          },
        ],
        companyType: COMPANY_TYPES.NON_BANK,
        ratioGroupCode: 'AverageCostOfFinancingAndCreditCost',
      }
    case typeComponentNonBank.EARNING_QUALITY:
      return {
        [typeViewBy.TREND]: [
          {
            label: null,
            indicators: [
              { id: 'FA150' },
              { id: 'RT0252' },
              { id: 'RT0060' },
              { id: 'RT0059' },
            ],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: null,
            indicators: [
              { id: 'FA150' },
              { id: 'RT0252' },
              { id: 'RT0060' },
              { id: 'RT0059' },
            ],
          },
        ],
        companyType: COMPANY_TYPES.NON_BANK,
        ratioGroupCode: 'EarningsQuality',
      }
    case typeComponentNonBank.CAPITAL_AND_LEVERAGE:
      return {
        [typeViewBy.TREND]: [
          {
            label: null,
            indicators: [{ id: 'RT0248' }, { id: 'NB219' }, { id: 'FA060' }],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: null,
            indicators: [{ id: 'RT0248' }, { id: 'NB219' }, { id: 'FA060' }],
          },
        ],
        companyType: COMPANY_TYPES.NON_BANK,
        ratioGroupCode: 'CapitalAndLeverage',
      }
    case typeComponentNonBank.LIQUIDITY:
      return {
        [typeViewBy.TREND]: [
          {
            label: null,
            indicators: [
              { id: 'RT0277' },
              { id: 'FA111' },
              { id: 'RT0318' },
              { id: 'FA149' },
            ],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: null,
            indicators: [
              { id: 'RT0277' },
              { id: 'FA111' },
              { id: 'RT0318' },
              { id: 'FA149' },
            ],
          },
        ],
        companyType: COMPANY_TYPES.NON_BANK,
        ratioGroupCode: 'Liquidity',
      }
    case typeComponentNonBank.FUNDING_STRUCTURE:
      return {
        [typeViewBy.TREND]: [
          {
            label: null,
            indicators: [
              { id: 'BS178' },
              { id: 'BS174' },
              { id: 'BS175' },
              { id: 'BS180' },
              { id: 'BS181' },
              { id: 'FA031' },
            ],
          },
        ],
        [typeViewBy.EACH_YEAR]: [
          {
            label: null,
            indicators: [
              { id: 'FA032' },
              { id: 'FA033' },
              { id: 'FA034' },
              { id: 'FA035' },
              { id: 'FA036' },
            ],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: null,
            indicators: [
              { id: 'BS178' },
              { id: 'FA032' },
              { id: 'BS174' },
              { id: 'FA033' },
              { id: 'BS175' },
              { id: 'FA034' },
              { id: 'BS180' },
              { id: 'FA035' },
              { id: 'BS181' },
              { id: 'FA036' },
              { id: 'FA156' },
              { id: 'FA031' },
            ],
          },
        ],
        companyType: COMPANY_TYPES.NON_BANK,
        ratioGroupCode: 'Funding',
      }
    case typeComponentNonBank.BALANCE_BREAKDOWN:
      return {
        [typeViewBy.TREND]: [
          {
            label: 'financialAnalysis.ASSET_STRUCTURE',
            indicators: [
              { id: 'BS2', enable: true },
              { id: 'FA037', enable: true },
              { id: 'FA038', enable: true },
              { id: 'BS158', enable: true },
              { id: 'FA039', enable: true },
              { id: 'FA040', enable: true },
              { id: 'RT0296', enable: true },
              { id: 'RT0172', enable: true },
            ],
          },
          {
            label: 'financialAnalysis.LIABILITIES_STRUCTURE',
            indicators: [
              { id: 'BS174', enable: true },
              { id: 'BS175', enable: true },
              { id: 'BS178', enable: true },
              { id: 'BS181', enable: true },
              { id: 'FA047', enable: true },
              { id: 'FA048', enable: true },
            ],
          },
          {
            label: 'financialAnalysis.EQUITY_STRUCTURE',
            indicators: [
              { id: 'BS186', enable: true },
              { id: 'BS187', enable: true },
              { id: 'BS109', enable: true },
              { id: 'FA054', enable: true },
              { id: 'RT0173', enable: true },
            ],
          },
        ],
        [typeViewBy.EACH_YEAR]: [
          {
            label: 'financialAnalysis.ASSET_STRUCTURE',
            indicators: [
              { id: 'FA153' },
              { id: 'FA041' },
              { id: 'FA042' },
              { id: 'FA043' },
              { id: 'FA044' },
              { id: 'FA045' },
              { id: 'FA046' },
            ],
          },
          {
            label: 'financialAnalysis.RESOURCE_STRUCTURE',
            indicators: [
              { id: 'FA160' },
              { id: 'FA159' },
              { id: 'FA055' },
              { id: 'FA049' },
              { id: 'FA050' },
              { id: 'FA056' },
              { id: 'FA051' },
              { id: 'FA057' },
              { id: 'FA052' },
              { id: 'FA053' },
            ],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: 'financialAnalysis.ASSET_STRUCTURE',
            indicators: [
              { id: 'BS2' },
              { id: 'FA037' },
              { id: 'FA038' },
              { id: 'BS158' },
              { id: 'FA039' },
              { id: 'FA040' },
              { id: 'BS64' },
              { id: 'RT0296' },
              { id: 'RT0172' },
            ],
          },
          {
            label: 'financialAnalysis.LIABILITIES_STRUCTURE',
            indicators: [
              { id: 'BS174' },
              { id: 'BS175' },
              { id: 'BS178' },
              { id: 'FA052' },
              { id: 'FA047' },
              { id: 'BS65' },
              { id: 'FA048' },
            ],
          },
          {
            label: 'financialAnalysis.EQUITY_STRUCTURE',
            indicators: [
              { id: 'BS186' },
              { id: 'BS187' },
              { id: 'BS109' },
              { id: 'FA054' },
              { id: 'BS95' },
              { id: 'RT0173' },
            ],
          },
        ],
        companyType: COMPANY_TYPES.NON_BANK,
        ratioGroupCode: 'BalanceSheetBreakdown',
      }
    case typeComponentNonBank.EARNING_BREAKDOWN:
      return {
        [typeViewBy.TREND]: [
          {
            label: null,
            indicators: [
              { id: 'IS27', enable: true },
              { id: 'IS30', enable: true },
              { id: 'FA059', enable: true },
              { id: 'IS39', enable: true },
              { id: 'IS41', enable: true },
              { id: 'IS16', enable: true },
            ],
          },
        ],
        [typeViewBy.EACH_YEAR]: [
          {
            label: null,
            indicators: [
              { id: 'IS27' },
              { id: 'IS30' },
              { id: 'FA059' },
              { id: 'IS39' },
              { id: 'IS41' },
              { id: 'IS16' },
            ],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: null,
            indicators: [
              { id: 'IS27' },
              { id: 'IS30' },
              { id: 'FA059' },
              { id: 'IS39' },
              { id: 'IS41' },
              { id: 'IS16' },
            ],
          },
        ],
        companyType: COMPANY_TYPES.NON_BANK,
        ratioGroupCode: 'EarningsBreakdown',
      }
    case typeComponentNonBank.CASH_FLOW:
      return {
        [typeViewBy.TREND]: [
          {
            label: null,
            indicators: [
              { id: 'CF19', enable: true },
              { id: 'CF30', enable: true },
              { id: 'CF37', enable: true },
              { id: 'CF38', enable: true },
            ],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: null,
            indicators: [
              { id: 'CF19' },
              { id: 'CF30' },
              { id: 'CF37' },
              { id: 'CF38' },
            ],
          },
        ],
        companyType: COMPANY_TYPES.NON_BANK,
        ratioGroupCode: 'CashFlowBreakdown',
      }
    // security
    case typeComponentSecurity.OPERATING_INCOME:
      return {
        [typeViewBy.TREND]: [
          {
            label: 'financialAnalysis.OPERATING_INCOME_BREAKDOWN',
            indicators: [
              { id: 'FA062', enable: true },
              { id: 'IS111', enable: true },
              { id: 'IS114', enable: true },
              { id: 'FA063', enable: true },
              { id: 'FA064', enable: true },
            ],
          },
          {
            label: 'financialAnalysis.GAIN_PROPRIETARY_TRADING_BREAKDOWN',
            indicators: [
              { id: 'IS106', enable: true },
              { id: 'IS110', enable: true },
              { id: 'IS112', enable: true },
            ],
          },
        ],
        [typeViewBy.EACH_YEAR]: [
          {
            label: 'financialAnalysis.OPERATING_INCOME_BREAKDOWN',
            indicators: [
              { id: 'FA155' },
              { id: 'FA065' },
              { id: 'FA066' },
              { id: 'FA067' },
              { id: 'FA068' },
              { id: 'FA069' },
            ],
          },
          {
            label: 'financialAnalysis.GAIN_PROPRIETARY_TRADING_BREAKDOWN',
            indicators: [{ id: 'FA070' }, { id: 'FA071' }, { id: 'FA072' }],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: 'financialAnalysis.OPERATING_INCOME_BREAKDOWN',
            indicators: [
              { id: 'IS3' },
              { id: 'FA062' },
              { id: 'IS111' },
              { id: 'IS114' },
              { id: 'FA063' },
              { id: 'FA069' },
            ],
          },
          {
            label: 'financialAnalysis.GAIN_PROPRIETARY_TRADING_BREAKDOWN',
            indicators: [{ id: 'IS106' }, { id: 'IS110' }, { id: 'IS112' }],
          },
        ],
        companyType: COMPANY_TYPES.SECURITIES,
        ratioGroupCode: 'OperatingIncome',
      }
    case typeComponentSecurity.BUSINESS_POSITION:
      return {
        [typeViewBy.TREND]: [
          {
            label: null,
            indicators: [
              { id: 'IS3', enable: true },
              { id: 'BS64', enable: true },
              { id: 'FA073', enable: true },
              { id: 'FA074', enable: true },
            ],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: null,
            indicators: [
              { id: 'IS3' },
              { id: 'BS64' },
              { id: 'FA073' },
              { id: 'FA074' },
            ],
          },
        ],
        companyType: COMPANY_TYPES.SECURITIES,
        ratioGroupCode: 'BusinessPosition',
      }
    case typeComponentSecurity.FINANCIAL_ASSET:
      return {
        [typeViewBy.TREND]: [
          {
            label: null,
            indicators: [
              { id: 'BS249', enable: true },
              { id: 'FA075', enable: true },
              { id: 'FA076', enable: true },
              { id: 'FA077', enable: true },
            ],
          },
        ],
        [typeViewBy.EACH_YEAR]: [
          {
            label: null,
            indicators: [
              { id: 'FA078' },
              { id: 'FA079' },
              { id: 'FA080' },
              { id: 'FA081' },
              { id: 'FA112' },
              { id: 'FA113' },
            ],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: null,
            indicators: [
              { id: 'BS249' },
              { id: 'FA078' },
              { id: 'FA075' },
              { id: 'FA079' },
              { id: 'FA076' },
              { id: 'FA080' },
              { id: 'FA077' },
              { id: 'FA081' },
              { id: 'FA158' },
              { id: 'FA112' },
              { id: 'FA113' },
            ],
          },
        ],
        companyType: COMPANY_TYPES.SECURITIES,
        ratioGroupCode: 'FinancialAssets',
      }
    case typeComponentSecurity.EARNING_QUALITY:
      return {
        [typeViewBy.TREND]: [
          {
            label: null,
            indicators: [
              { id: 'FA082' },
              { id: 'RT0060' },
              { id: 'FA083' },
              { id: 'RT0059' },
              { id: 'RTI0059' },
              { id: 'RTI0060' },
            ],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: null,
            indicators: [
              { id: 'FA082' },
              { id: 'RT0060' },
              { id: 'FA083' },
              { id: 'RT0059' },
              { id: 'RTI0059' },
              { id: 'RTI0060' },
            ],
          },
        ],
        companyType: COMPANY_TYPES.SECURITIES,
        ratioGroupCode: 'EarningsQuality',
      }
    case typeComponentSecurity.LEVERAGE:
      return {
        [typeViewBy.TREND]: [
          {
            label: null,
            indicators: [{ id: 'RT0034' }, { id: 'FA084' }],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: null,
            indicators: [{ id: 'RT0034' }, { id: 'FA084' }],
          },
        ],
        companyType: COMPANY_TYPES.SECURITIES,
        ratioGroupCode: 'Leverage',
      }
    case typeComponentSecurity.FUNDING_AND_LIQUIDITY:
      return {
        [typeViewBy.TREND]: [
          {
            label: null,
            indicators: [
              { id: 'RT0020' },
              { id: 'FA085', enable: true },
              { id: 'FA086', enable: true },
              { id: 'FA087', enable: true },
              { id: 'FA088', enable: true },
            ],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: null,
            indicators: [
              { id: 'RT0020' },
              { id: 'FA085' },
              { id: 'FA086' },
              { id: 'FA087' },
              { id: 'FA088' },
            ],
          },
        ],
        companyType: COMPANY_TYPES.SECURITIES,
        ratioGroupCode: 'FundingAndLiquidity',
      }
    case typeComponentSecurity.EARNING_BREAKDOWN:
      return {
        [typeViewBy.TREND]: [
          {
            label: null,
            indicators: [
              { id: 'IS3', enable: true },
              { id: 'IS6', enable: true },
              { id: 'IS7', enable: true },
              { id: 'IS4', enable: true },
              { id: 'FA089', enable: true },
              { id: 'IS13', enable: true },
              { id: 'IS14', enable: true },
              { id: 'IS16', enable: true },
            ],
          },
        ],
        [typeViewBy.EACH_YEAR]: [
          {
            label: null,
            indicators: [
              { id: 'IS3' },
              { id: 'IS6' },
              { id: 'IS7' },
              { id: 'IS4' },
              { id: 'FA089' },
              { id: 'IS15' },
            ],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: null,
            indicators: [
              { id: 'IS3' },
              { id: 'IS6' },
              { id: 'IS7' },
              { id: 'IS4' },
              { id: 'FA089' },
              { id: 'IS13' },
              { id: 'IS14' },
              { id: 'IS15' },
              { id: 'IS16' },
            ],
          },
        ],
        companyType: COMPANY_TYPES.SECURITIES,
        ratioGroupCode: 'EarningsBreakdown',
      }
    case typeComponentSecurity.BALANCE_BREAKDOWN:
      return {
        [typeViewBy.TREND]: [
          {
            label: 'financialAnalysis.ASSET_STRUCTURE',
            indicators: [
              { id: 'FA090', enable: true },
              { id: 'BS250', enable: true },
              { id: 'BS265', enable: true },
              { id: 'BS36', enable: true },
              { id: 'BS46', enable: true },
              { id: 'BS49', enable: true },
              { id: 'FA091', enable: true },
              { id: 'RT0172', enable: true },
            ],
          },
          {
            label: 'financialAnalysis.LIABILITIES_STRUCTURE',
            indicators: [
              { id: 'BS66', enable: true },
              { id: 'BS81', enable: true },
              { id: 'FA099', enable: true },
            ],
          },
          {
            label: 'financialAnalysis.EQUITY_STRUCTURE',
            indicators: [
              { id: 'BS293', enable: true },
              { id: 'BS294', enable: true },
              { id: 'BS138', enable: true },
              { id: 'BS109', enable: true },
              { id: 'FA102', enable: true },
              { id: 'RT0173', enable: true },
            ],
          },
        ],
        [typeViewBy.EACH_YEAR]: [
          {
            label: 'financialAnalysis.ASSET_STRUCTURE',
            indicators: [
              { id: 'FA154' },
              { id: 'FA092' },
              { id: 'FA093' },
              { id: 'FA094' },
              { id: 'FA095' },
              { id: 'FA096' },
              { id: 'FA097' },
              { id: 'FA098' },
            ],
          },
          {
            label: 'financialAnalysis.RESOURCE_STRUCTURE',
            indicators: [
              { id: 'FA160' },
              { id: 'FA103' },
              { id: 'FA100' },
              { id: 'FA104' },
              { id: 'FA101' },
              { id: 'FA105' },
              { id: 'FA106' },
              { id: 'FA107' },
            ],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: 'financialAnalysis.ASSET_STRUCTURE',
            indicators: [
              { id: 'FA090' },
              { id: 'BS250' },
              { id: 'BS265' },
              { id: 'BS36' },
              { id: 'BS46' },
              { id: 'BS49' },
              { id: 'FA091' },
              { id: 'BS64' },
              { id: 'RT0172' },
            ],
          },
          {
            label: 'financialAnalysis.LIABILITIES_STRUCTURE',
            indicators: [
              { id: 'BS66' },
              { id: 'BS81' },
              { id: 'BS65' },
              { id: 'FA099' },
            ],
          },
          {
            label: 'financialAnalysis.EQUITY_STRUCTURE',
            indicators: [
              { id: 'BS293' },
              { id: 'BS294' },
              { id: 'BS138' },
              { id: 'BS109' },
              { id: 'FA102' },
              { id: 'BS95' },
              { id: 'RT0173' },
            ],
          },
        ],
        companyType: COMPANY_TYPES.SECURITIES,
        ratioGroupCode: 'BalanceSheetBreakdown',
      }
    case typeComponentSecurity.CASH_FLOW:
      return {
        [typeViewBy.TREND]: [
          {
            label: null,
            indicators: [
              { id: 'CF19', enable: true },
              { id: 'CF30', enable: true },
              { id: 'CF37', enable: true },
              { id: 'CF38', enable: true },
            ],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: null,
            indicators: [
              { id: 'CF19' },
              { id: 'CF30' },
              { id: 'CF37' },
              { id: 'CF38' },
            ],
          },
        ],
        companyType: COMPANY_TYPES.SECURITIES,
        ratioGroupCode: 'CashFlowBreakdown',
      }
    // life insurance
    case typeComponentLifeInsurance.INSURANCE_PREMIUM_REVENUE:
      return {
        [typeViewBy.TREND]: [
          {
            label: null,
            indicators: [
              { id: 'IS1', enable: true },
              { id: 'IS45', enable: true },
              { id: 'IS51', enable: true },
              { id: 'FA269', enable: true },
              { id: 'RT0418', enable: true },
              { id: 'RT0419', enable: true },
            ],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: null,
            indicators: [
              { id: 'IS1' },
              { id: 'FA269' },
              { id: 'IS42' },
              { id: 'FA268' },
              { id: 'IS45' },
              { id: 'RT0418' },
              { id: 'IS51' },
              { id: 'RT0419' },
            ],
          },
        ],
        companyType: COMPANY_TYPES.LIFE_INSURANCE,
        ratioGroupCode: 'InsurancePremiumRevenue',
      }
    case typeComponentLifeInsurance.OPERATIONAL_EFFICIENCY:
      return {
        [typeViewBy.TREND]: [
          {
            label: null,
            indicators: [
              { id: 'RT2017', enable: true },
              { id: 'RTG2017', enable: true },
              { id: 'RT0420', enable: true },
              { id: 'RTG0420', enable: true },
              { id: 'RT2018', enable: true },
              { id: 'RTG2018', enable: true },
            ],
          },
        ],
        [typeViewBy.EACH_YEAR]: [
          {
            label: null,
            indicators: [
              { id: 'RT2017' },
              { id: 'RTG2017' },
              { id: 'RT0420' },
              { id: 'RTG0420' },
              { id: 'RT2018' },
              { id: 'RTG2018' },
            ],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: null,
            indicators: [
              { id: 'RT2017' },
              { id: 'RTG2017' },
              { id: 'RT0420' },
              { id: 'RTG0420' },
              { id: 'RT2018' },
              { id: 'RTG2018' },
            ],
          },
        ],
        companyType: COMPANY_TYPES.LIFE_INSURANCE,
        ratioGroupCode: 'OperationalEfficiency',
      }
    case typeComponentLifeInsurance.PROFITABILITY:
      return {
        [typeViewBy.TREND]: [
          {
            label: null,
            indicators: [
              { id: 'IS51', enable: true },
              { id: 'IS91', enable: true },
              { id: 'IS94', enable: true },
              { id: 'IS16', enable: true },
              { id: 'RT0050', enable: true },
              { id: 'RT0416', enable: true },
              { id: 'RT2002', enable: true },
            ],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: null,
            indicators: [
              { id: 'IS51' },
              { id: 'IS91' },
              { id: 'IS94' },
              { id: 'IS16' },
              { id: 'RT0050' },
              { id: 'RT0416' },
              { id: 'RT2002' },
            ],
          },
        ],
        companyType: COMPANY_TYPES.LIFE_INSURANCE,
        ratioGroupCode: 'Profitability',
      }
    case typeComponentLifeInsurance.ROA_AND_ROE:
      return {
        [typeViewBy.TREND]: [
          {
            label: null,
            indicators: [
              { id: 'RT2003' },
              { id: 'RTG2003' },
              { id: 'RT2004' },
              { id: 'RTG2004' },
            ],
          },
        ],
        [typeViewBy.EACH_YEAR]: [
          {
            label: null,
            indicators: [
              { id: 'RT2004' },
              { id: 'RT2003' },
              { id: 'RT0035' },
              { id: 'RT2002' },
              { id: 'RT0003' },
              { id: 'FA001' },
              { id: 'RT0065' },
              { id: 'RT0052' },
            ],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: null,
            indicators: [
              { id: 'RT2003' },
              { id: 'RTG2003' },
              { id: 'RT2004' },
              { id: 'RTG2004' },
              { id: 'RT0035' },
              { id: 'RT2002' },
              { id: 'RT0003' },
              { id: 'FA001' },
              { id: 'RT0065' },
              { id: 'RT0052' },
            ],
          },
        ],
        companyType: COMPANY_TYPES.LIFE_INSURANCE,
        ratioGroupCode: 'RoaAndRoe',
      }
    case typeComponentLifeInsurance.INSURANCE_SOLVENCY:
      return {
        [typeViewBy.TREND]: [
          {
            label: null,
            indicators: [
              { id: 'RT0033' },
              { id: 'RTG0033' },
              { id: 'RT0417' },
              { id: 'RTG0417' },
            ],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: null,
            indicators: [
              { id: 'RT0033' },
              { id: 'RTG0033' },
              { id: 'RT0417' },
              { id: 'RTG0417' },
            ],
          },
        ],
        companyType: COMPANY_TYPES.LIFE_INSURANCE,
        ratioGroupCode: 'InsuranceSolvency',
      }
    case typeComponentLifeInsurance.LIQUIDITY:
      return {
        [typeViewBy.TREND]: [
          {
            label: null,
            indicators: [
              { id: 'RT0020' },
              { id: 'RTG0020' },
              { id: 'RT0019' },
              { id: 'RTG0019' },
              { id: 'RT0018' },
              { id: 'RTG0018' },
            ],
          },
        ],
        [typeViewBy.EACH_YEAR]: [
          {
            label: null,
            indicators: [
              { id: 'RT0020' },
              { id: 'RTG0020' },
              { id: 'RT0019' },
              { id: 'RTG0019' },
              { id: 'RT0018' },
              { id: 'RTG0018' },
              { id: 'RT0001' },
              { id: 'RT0040' },
            ],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: null,
            indicators: [
              { id: 'RT0020' },
              { id: 'RTG0020' },
              { id: 'RT0019' },
              { id: 'RTG0019' },
              { id: 'RT0018' },
              { id: 'RTG0018' },
              { id: 'RT0001' },
              { id: 'RT0040' },
            ],
          },
        ],
        companyType: COMPANY_TYPES.LIFE_INSURANCE,
        ratioGroupCode: 'Liquidity',
      }
    case typeComponentLifeInsurance.EARNING_BREAKDOWN:
      return {
        [typeViewBy.TREND]: [
          {
            label: null,
            indicators: [
              { id: 'FA304', enable: true },
              { id: 'FA305', enable: true },
              { id: 'FA306', enable: true },
              { id: 'FA307', enable: true },
              { id: 'FA308', enable: true },
              { id: 'FA309', enable: true },
              { id: 'FA310', enable: true },
              { id: 'FA311', enable: true },
              { id: 'FA312', enable: true },
              { id: 'FA314', enable: true },
              { id: 'FA315', enable: true },
              { id: 'FA317', enable: true },
              { id: 'FA318', enable: true },
              { id: 'FA320', enable: true },
              { id: 'FA321', enable: true },
              { id: 'FA322', enable: true },
              { id: 'FA323', enable: true },
            ],
          },
        ],
        [typeViewBy.EACH_YEAR]: [
          {
            label: null,
            indicators: [
              { id: 'FA304' },
              { id: 'FA305' },
              { id: 'FA306' },
              { id: 'FA307' },
              { id: 'FA308' },
              { id: 'FA309' },
              { id: 'FA310' },
              { id: 'FA313' },
              { id: 'FA316' },
              { id: 'FA319' },
              { id: 'FA320' },
              { id: 'FA321' },
              { id: 'FA322' },
              { id: 'FA323' },
            ],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: null,
            indicators: [
              { id: 'FA304' },
              { id: 'FA305' },
              { id: 'FA306' },
              { id: 'FA307' },
              { id: 'FA308' },
              { id: 'FA309' },
              { id: 'FA310' },
              { id: 'FA311' },
              { id: 'FA312' },
              { id: 'FA313' },
              { id: 'FA314' },
              { id: 'FA315' },
              { id: 'FA316' },
              { id: 'FA317' },
              { id: 'FA318' },
              { id: 'FA319' },
              { id: 'FA320' },
              { id: 'FA321' },
              { id: 'FA322' },
              { id: 'FA323' },
            ],
          },
        ],
        companyType: COMPANY_TYPES.LIFE_INSURANCE,
        ratioGroupCode: 'EarningsBreakdown',
      }
    case typeComponentLifeInsurance.BALANCE_BREAKDOWN:
      return {
        [typeViewBy.TREND]: [
          {
            label: 'financialAnalysis.ASSET_STRUCTURE',
            indicators: [
              { id: 'BS2', enable: true },
              { id: 'BS5', enable: true },
              { id: 'BS9', enable: true },
              { id: 'BS217', enable: true },
              { id: 'BS36', enable: true },
              { id: 'BS46', enable: true },
              { id: 'BS52', enable: true },
              { id: 'FA201', enable: true },
              { id: 'RT0172', enable: true },
            ],
          },
          {
            label: 'financialAnalysis.LIABILITIES_STRUCTURE',
            indicators: [
              { id: 'BS66', enable: true },
              { id: 'BS229', enable: true },
              { id: 'FA210', enable: true },
              { id: 'FA018', enable: true },
            ],
          },
          {
            label: 'financialAnalysis.EQUITY_STRUCTURE',
            indicators: [
              { id: 'FA024', enable: true },
              { id: 'BS109', enable: true },
              { id: 'FA025', enable: true },
              { id: 'RT0173', enable: true },
            ],
          },
        ],
        [typeViewBy.EACH_YEAR]: [
          {
            label: 'financialAnalysis.ASSET_STRUCTURE',
            indicators: [
              { id: 'FA222' },
              { id: 'FA202' },
              { id: 'FA203' },
              { id: 'FA204' },
              { id: 'FA205' },
              { id: 'FA206' },
              { id: 'FA207' },
              { id: 'FA208' },
              { id: 'FA209' },
            ],
          },
          {
            label: 'financialAnalysis.RESOURCE_STRUCTURE',
            indicators: [
              { id: 'FA159' },
              { id: 'FA211' },
              { id: 'FA212' },
              { id: 'FA213' },
              { id: 'FA160' },
              { id: 'FA026' },
              { id: 'FA027' },
              { id: 'FA028' },
            ],
          },
          {
            label: 'financialAnalysis.SHORT_TERM_INVESTMENT',
            indicators: [{ id: 'FA214' }, { id: 'FA215' }],
          },
          {
            label: 'financialAnalysis.LONG_TERM_INVESTMENT',
            indicators: [
              { id: 'FA216' },
              { id: 'FA217' },
              { id: 'FA218' },
              { id: 'FA219' },
              { id: 'FA220' },
              { id: 'FA221' },
            ],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: 'financialAnalysis.ASSET_STRUCTURE',
            indicators: [
              { id: 'BS2' },
              { id: 'BS5' },
              { id: 'BS9' },
              { id: 'BS217' },
              { id: 'BS36' },
              { id: 'BS46' },
              { id: 'BS52' },
              { id: 'FA201' },
              { id: 'RT0172' },
              { id: 'BS64' },
            ],
          },
          {
            label: 'financialAnalysis.LIABILITIES_STRUCTURE',
            indicators: [
              { id: 'BS66' },
              { id: 'BS229' },
              { id: 'FA210' },
              { id: 'FA018' },
              { id: 'FA211' },
              { id: 'FA212' },
              { id: 'FA213' },
            ],
          },
          {
            label: 'financialAnalysis.EQUITY_STRUCTURE',
            indicators: [
              { id: 'FA024' },
              { id: 'FA026' },
              { id: 'BS109' },
              { id: 'FA027' },
              { id: 'FA025' },
              { id: 'FA028' },
              { id: 'BS95' },
              { id: 'RT0173' },
            ],
          },
          {
            label: 'financialAnalysis.SHORT_TERM_INVESTMENT',
            indicators: [
              { id: 'NI7' },
              { id: 'NI8' },
              { id: 'FA214' },
              { id: 'FA215' },
            ],
          },
          {
            label: 'financialAnalysis.LONG_TERM_INVESTMENT',
            indicators: [
              { id: 'NI72' },
              { id: 'NI73' },
              { id: 'NI74' },
              { id: 'NI75' },
              { id: 'NI76' },
              { id: 'NI77' },
              { id: 'FA216' },
              { id: 'FA217' },
              { id: 'FA218' },
              { id: 'FA219' },
              { id: 'FA220' },
              { id: 'FA221' },
            ],
          },
        ],
        companyType: COMPANY_TYPES.LIFE_INSURANCE,
        ratioGroupCode: 'BalanceSheetBreakdown',
      }
    case typeComponentLifeInsurance.CASH_FLOW:
      return {
        [typeViewBy.TREND]: [
          {
            label: null,
            indicators: [
              { id: 'CF19', enable: true },
              { id: 'CF30', enable: true },
              { id: 'CF37', enable: true },
              { id: 'CF38', enable: true },
            ],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: null,
            indicators: [
              { id: 'CF19' },
              { id: 'CF30' },
              { id: 'CF37' },
              { id: 'CF38' },
            ],
          },
        ],
        companyType: COMPANY_TYPES.LIFE_INSURANCE,
        ratioGroupCode: 'CashFlowBreakdown',
      }
    // non life insurance
    case typeComponentNonLifeInsurance.INSURANCE_PREMIUM_REVENUE:
      return {
        [typeViewBy.TREND]: [
          {
            label: null,
            indicators: [
              { id: 'IS1', enable: true },
              { id: 'IS45', enable: true },
              { id: 'IS51', enable: true },
              { id: 'FA269', enable: true },
              { id: 'RT0418', enable: true },
              { id: 'RT0419', enable: true },
            ],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: null,
            indicators: [
              { id: 'IS1' },
              { id: 'FA269' },
              { id: 'IS42' },
              { id: 'FA268' },
              { id: 'IS45' },
              { id: 'RT0418' },
              { id: 'IS51' },
              { id: 'RT0419' },
            ],
          },
        ],
        companyType: COMPANY_TYPES.NON_LIFE_INSURANCE,
        ratioGroupCode: 'InsurancePremiumRevenue',
      }
    case typeComponentNonLifeInsurance.OPERATIONAL_EFFICIENCY:
      return {
        [typeViewBy.TREND]: [
          {
            label: null,
            indicators: [
              { id: 'RT2017', enable: true },
              { id: 'RTG2017', enable: true },
              { id: 'RT0420', enable: true },
              { id: 'RTG0420', enable: true },
              { id: 'RT2018', enable: true },
              { id: 'RTG2018', enable: true },
            ],
          },
        ],
        [typeViewBy.EACH_YEAR]: [
          {
            label: null,
            indicators: [
              { id: 'RT2017' },
              { id: 'RTG2017' },
              { id: 'RT0420' },
              { id: 'RTG0420' },
              { id: 'RT2018' },
              { id: 'RTG2018' },
            ],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: null,
            indicators: [
              { id: 'RT2017' },
              { id: 'RTG2017' },
              { id: 'RT0420' },
              { id: 'RTG0420' },
              { id: 'RT2018' },
              { id: 'RTG2018' },
            ],
          },
        ],
        companyType: COMPANY_TYPES.NON_LIFE_INSURANCE,
        ratioGroupCode: 'OperationalEfficiency',
      }
    case typeComponentNonLifeInsurance.PROFITABILITY:
      return {
        [typeViewBy.TREND]: [
          {
            label: null,
            indicators: [
              { id: 'IS51', enable: true },
              { id: 'IS91', enable: true },
              { id: 'IS94', enable: true },
              { id: 'IS16', enable: true },
              { id: 'RT0050', enable: true },
              { id: 'RT0416', enable: true },
              { id: 'RT2002', enable: true },
            ],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: null,
            indicators: [
              { id: 'IS51' },
              { id: 'IS91' },
              { id: 'IS94' },
              { id: 'IS16' },
              { id: 'RT0050' },
              { id: 'RT0416' },
              { id: 'RT2002' },
            ],
          },
        ],
        companyType: COMPANY_TYPES.NON_LIFE_INSURANCE,
        ratioGroupCode: 'Profitability',
      }
    case typeComponentNonLifeInsurance.ROA_AND_ROE:
      return {
        [typeViewBy.TREND]: [
          {
            label: null,
            indicators: [
              { id: 'RT2003' },
              { id: 'RTG2003' },
              { id: 'RT2004' },
              { id: 'RTG2004' },
            ],
          },
        ],
        [typeViewBy.EACH_YEAR]: [
          {
            label: null,
            indicators: [
              { id: 'RT2004' },
              { id: 'RT2003' },
              { id: 'RT0035' },
              { id: 'RT2002' },
              { id: 'RT0003' },
              { id: 'FA001' },
              { id: 'RT0065' },
              { id: 'RT0052' },
            ],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: null,
            indicators: [
              { id: 'RT2003' },
              { id: 'RTG2003' },
              { id: 'RT2004' },
              { id: 'RTG2004' },
              { id: 'RT0035' },
              { id: 'RT2002' },
              { id: 'RT0003' },
              { id: 'FA001' },
              { id: 'RT0065' },
              { id: 'RT0052' },
            ],
          },
        ],
        companyType: COMPANY_TYPES.NON_LIFE_INSURANCE,
        ratioGroupCode: 'RoaAndRoe',
      }
    case typeComponentNonLifeInsurance.INSURANCE_SOLVENCY:
      return {
        [typeViewBy.TREND]: [
          {
            label: null,
            indicators: [
              { id: 'RT0033' },
              { id: 'RTG0033' },
              { id: 'RT0417' },
              { id: 'RTG0417' },
            ],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: null,
            indicators: [
              { id: 'RT0033' },
              { id: 'RTG0033' },
              { id: 'RT0417' },
              { id: 'RTG0417' },
            ],
          },
        ],
        companyType: COMPANY_TYPES.NON_LIFE_INSURANCE,
        ratioGroupCode: 'InsuranceSolvency',
      }
    case typeComponentNonLifeInsurance.LIQUIDITY:
      return {
        [typeViewBy.TREND]: [
          {
            label: null,
            indicators: [
              { id: 'RT0020' },
              { id: 'RTG0020' },
              { id: 'RT0019' },
              { id: 'RTG0019' },
              { id: 'RT0018' },
              { id: 'RTG0018' },
            ],
          },
        ],
        [typeViewBy.EACH_YEAR]: [
          {
            label: null,
            indicators: [
              { id: 'RT0020' },
              { id: 'RTG0020' },
              { id: 'RT0019' },
              { id: 'RTG0019' },
              { id: 'RT0018' },
              { id: 'RTG0018' },
              { id: 'RT0001' },
              { id: 'RT0040' },
            ],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: null,
            indicators: [
              { id: 'RT0020' },
              { id: 'RTG0020' },
              { id: 'RT0019' },
              { id: 'RTG0019' },
              { id: 'RT0018' },
              { id: 'RTG0018' },
              { id: 'RT0001' },
              { id: 'RT0040' },
            ],
          },
        ],
        companyType: COMPANY_TYPES.NON_LIFE_INSURANCE,
        ratioGroupCode: 'Liquidity',
      }
    case typeComponentNonLifeInsurance.EARNING_BREAKDOWN:
      return {
        [typeViewBy.TREND]: [
          {
            label: null,
            indicators: [
              { id: 'FA324', enable: true },
              { id: 'FA325', enable: true },
              { id: 'FA326', enable: true },
              { id: 'FA327', enable: true },
              { id: 'FA328', enable: true },
              { id: 'FA329', enable: true },
              { id: 'FA330', enable: true },
              { id: 'FA331', enable: true },
              { id: 'FA332', enable: true },
              { id: 'FA334', enable: true },
              { id: 'FA335', enable: true },
              { id: 'FA337', enable: true },
              { id: 'FA338', enable: true },
              { id: 'FA339', enable: true },
              { id: 'FA341', enable: true },
              { id: 'FA342', enable: true },
              { id: 'FA343', enable: true },
              { id: 'FA344', enable: true },
            ],
          },
        ],
        [typeViewBy.EACH_YEAR]: [
          {
            label: null,
            indicators: [
              { id: 'FA324' },
              { id: 'FA325' },
              { id: 'FA326' },
              { id: 'FA327' },
              { id: 'FA328' },
              { id: 'FA329' },
              { id: 'FA330' },
              { id: 'FA333' },
              { id: 'FA336' },
              { id: 'FA337' },
              { id: 'FA340' },
              { id: 'FA341' },
              { id: 'FA342' },
              { id: 'FA343' },
              { id: 'FA344' },
            ],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: null,
            indicators: [
              { id: 'FA324' },
              { id: 'FA325' },
              { id: 'FA326' },
              { id: 'FA327' },
              { id: 'FA328' },
              { id: 'FA329' },
              { id: 'FA330' },
              { id: 'FA331' },
              { id: 'FA332' },
              { id: 'FA333' },
              { id: 'FA334' },
              { id: 'FA335' },
              { id: 'FA336' },
              { id: 'FA337' },
              { id: 'FA338' },
              { id: 'FA339' },
              { id: 'FA340' },
              { id: 'FA341' },
              { id: 'FA342' },
              { id: 'FA343' },
              { id: 'FA344' },
            ],
          },
        ],
        companyType: COMPANY_TYPES.NON_LIFE_INSURANCE,
        ratioGroupCode: 'EarningsBreakdown',
      }
    case typeComponentNonLifeInsurance.BALANCE_BREAKDOWN:
      return {
        [typeViewBy.TREND]: [
          {
            label: 'financialAnalysis.ASSET_STRUCTURE',
            indicators: [
              { id: 'BS2', enable: true },
              { id: 'BS5', enable: true },
              { id: 'BS9', enable: true },
              { id: 'BS217', enable: true },
              { id: 'BS36', enable: true },
              { id: 'BS46', enable: true },
              { id: 'BS52', enable: true },
              { id: 'FA201', enable: true },
              { id: 'RT0172', enable: true },
            ],
          },
          {
            label: 'financialAnalysis.LIABILITIES_STRUCTURE',
            indicators: [
              { id: 'BS76', enable: true },
              { id: 'BS67', enable: true },
              { id: 'BS229', enable: true },
              { id: 'FA223', enable: true },
              { id: 'BS81', enable: true },
              { id: 'FA018', enable: true },
            ],
          },
          {
            label: 'financialAnalysis.EQUITY_STRUCTURE',
            indicators: [
              { id: 'FA024', enable: true },
              { id: 'BS109', enable: true },
              { id: 'FA025', enable: true },
              { id: 'RT0173', enable: true },
            ],
          },
        ],
        [typeViewBy.EACH_YEAR]: [
          {
            label: 'financialAnalysis.ASSET_STRUCTURE',
            indicators: [
              { id: 'FA222' },
              { id: 'FA202' },
              { id: 'FA203' },
              { id: 'FA204' },
              { id: 'FA205' },
              { id: 'FA206' },
              { id: 'FA207' },
              { id: 'FA208' },
              { id: 'FA209' },
            ],
          },
          {
            label: 'financialAnalysis.RESOURCE_STRUCTURE',
            indicators: [
              { id: 'FA159' },
              { id: 'FA224' },
              { id: 'FA225' },
              { id: 'FA226' },
              { id: 'FA227' },
              { id: 'FA228' },
              { id: 'FA160' },
              { id: 'FA026' },
              { id: 'FA027' },
              { id: 'FA028' },
            ],
          },
          {
            label: 'financialAnalysis.SHORT_TERM_INVESTMENT',
            indicators: [{ id: 'FA214' }, { id: 'FA215' }],
          },
          {
            label: 'financialAnalysis.LONG_TERM_INVESTMENT',
            indicators: [
              { id: 'FA216' },
              { id: 'FA217' },
              { id: 'FA218' },
              { id: 'FA219' },
              { id: 'FA220' },
              { id: 'FA221' },
            ],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: 'financialAnalysis.ASSET_STRUCTURE',
            indicators: [
              { id: 'BS2' },
              { id: 'BS5' },
              { id: 'BS9' },
              { id: 'BS217' },
              { id: 'BS36' },
              { id: 'BS46' },
              { id: 'BS52' },
              { id: 'FA201' },
              { id: 'RT0172' },
              { id: 'BS64' },
            ],
          },
          {
            label: 'financialAnalysis.LIABILITIES_STRUCTURE',
            indicators: [
              { id: 'BS76' },
              { id: 'BS67' },
              { id: 'BS229' },
              { id: 'FA223' },
              { id: 'BS81' },
              { id: 'BS65' },
              { id: 'FA018' },
            ],
          },
          {
            label: 'financialAnalysis.EQUITY_STRUCTURE',
            indicators: [
              { id: 'FA024' },
              { id: 'FA026' },
              { id: 'BS109' },
              { id: 'FA027' },
              { id: 'FA025' },
              { id: 'FA028' },
              { id: 'BS95' },
              { id: 'RT0173' },
            ],
          },
          {
            label: 'financialAnalysis.SHORT_TERM_INVESTMENT',
            indicators: [
              { id: 'NI7' },
              { id: 'NI8' },
              { id: 'FA214' },
              { id: 'FA215' },
            ],
          },
          {
            label: 'financialAnalysis.LONG_TERM_INVESTMENT',
            indicators: [
              { id: 'NI72' },
              { id: 'NI73' },
              { id: 'NI74' },
              { id: 'NI75' },
              { id: 'NI76' },
              { id: 'NI77' },
              { id: 'FA216' },
              { id: 'FA217' },
              { id: 'FA218' },
              { id: 'FA219' },
              { id: 'FA220' },
              { id: 'FA221' },
            ],
          },
        ],
        companyType: COMPANY_TYPES.NON_LIFE_INSURANCE,
        ratioGroupCode: 'BalanceSheetBreakdown',
      }
    case typeComponentNonLifeInsurance.CASH_FLOW:
      return {
        [typeViewBy.TREND]: [
          {
            label: null,
            indicators: [
              { id: 'CF19', enable: true },
              { id: 'CF30', enable: true },
              { id: 'CF37', enable: true },
              { id: 'CF38', enable: true },
            ],
          },
        ],
        [typeViewBy.TABLE]: [
          {
            label: null,
            indicators: [
              { id: 'CF19' },
              { id: 'CF30' },
              { id: 'CF37' },
              { id: 'CF38' },
            ],
          },
        ],
        companyType: COMPANY_TYPES.NON_LIFE_INSURANCE,
        ratioGroupCode: 'CashFlowBreakdown',
      }
    default:
      return {}
  }
}

export default getSettingPanel
